module.exports = __webpack_public_path__ + "img/Asset 4.png";